/*eslint-env browser*/

function attachStyleSheet({ backdrop, bezier, timing, blur, z }) {
  let css = `
  :root {
      --paella-superimage-backdrop-bg: ${backdrop};
      --paella-superimage-z-index: ${z};
      --paella-superimage-z-backdrop: ${z - 1};
      --paella-superimage-duration: ${timing};
      --paella-superimage-timing-func:${bezier};
  }
  [paella-superimage="img"] {
      position: relative;
      max-width: 100%;
      transition: transform var(--paella-superimage-duration) var(--paella-superimage-timing-func);
      box-shadow:var(--shadow);
    }

  [paella-superimage="wrap"] {
      position: relative;
      transition: transform var(--paella-superimage-duration) var(--paella-superimage-timing-func);
  }
  
  [paella-superimage-state="active"] {
      z-index: var(--paella-superimage-z-index);
  }

  [paella-superimage="backdrop"] {
      z-index: var(--paella-superimage-z-backdrop);
      position: fixed;
      background-color:var(--paella-superimage-backdrop-bg);
      opacity:0;
      top:0;
      left:0;
      right:0;
      bottom:0;
      width:100%;
      height:100%;
      visibility:hidden;
      pointer-events:none;
      transition: opacity var(--paella-superimage-duration) var(--paella-superimage-timing-func);
  }

  @supports (backdrop-filter: blur(30px)) {
      [paella-superimage="backdrop"]{
      backdrop-filter: blur(${blur});
    }
  }

 `;

  insertCss('paella-superimage-css', css);
}

function insertCss(styleId, styleContent) {
  let d = document;
  let head = d.head || d.getElementsByTagName('head')[0];

  // Remove existing instance
  if (d.getElementById(styleId)) {
    d.getElementById(styleId).remove();
  }

  // Create new instance
  let styleEl = d.createElement('style');
  styleEl.id = styleId;

  // Check if content exists
  if (styleEl.styleSheet) {
    styleEl.styleSheet.cssText = styleContent;
  } else {
    styleEl.appendChild(d.createTextNode(styleContent));
  }
  head.appendChild(styleEl);
}

export { attachStyleSheet };
